import type { ReactNode } from 'react';

import type { Device } from '../types';

import { DeviceCard } from './device-card';
import styles from './device-grid.module.scss';

export type DeviceGridProps = {
  devices: Device[];
  now?: number;
  /** Render the per-device power control (Slice 1). */
  renderPowerControl?: (device: Device) => ReactNode;
  /** Launch the configuration flow for an unconfigured device (story 101971). */
  onFinishSetup?: (device: Device) => void;
};

export function DeviceGrid({ devices, now, renderPowerControl, onFinishSetup }: DeviceGridProps) {
  return (
    <div className={styles.grid}>
      {devices.map((device) => (
        <DeviceCard
          key={device.id}
          device={device}
          now={now}
          powerControl={renderPowerControl?.(device)}
          onFinishSetup={onFinishSetup}
        />
      ))}
    </div>
  );
}
